import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import logo from '../assets/FooterPhotos/hdplogo.png';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer-custom mt-auto"> {/* Uklonio py-3 */}
      <Container className="text-center">
        <div className="footer-logo">
          <Link to="/">
            <img 
              src={logo} 
              height="55" // Smanjio sa 60 na 45
              alt="HDPMG Footer Logo" 
            />
          </Link>
        </div>

        <p className="footer-copyright">
          © HDPMG - 2026+
        </p>

        <Nav className="justify-content-center footer-nav">
          <Nav.Link 
            as={Link} to="/" 
            className={`footer-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Home
          </Nav.Link>
          
          <Nav.Link 
            as={Link} to="/about-us" 
            className={`footer-link ${location.pathname === '/about-us' ? 'active' : ''}`}
          >
            About Us
          </Nav.Link>
          
          <Nav.Link 
            as={Link} to="/contact-us" 
            className={`footer-link ${location.pathname === '/contact-us' ? 'active' : ''}`}
          >
            Contact Us
          </Nav.Link>
          
          <Nav.Link 
            as={Link} to="/portfolio-strategy" 
            className={`footer-link ${location.pathname === '/portfolio-strategy' ? 'active' : ''}`}
          >
            Portfolio Strategy
          </Nav.Link>
        </Nav>
      </Container>
    </footer>
  );
};

export default Footer;